import * as THREE from 'three'

/**
 * Oyuncaklar — tools/blender/toys.py (beyaz modeller, renk çalışma anında palet matcap'lerinden)
 * Yerler boş alanlara göre seçildi: dominolar giriş–kavşak yolunun doğusu, piramit batısı, toplar kavşakta.
 */
const COLORS = ['accent', 'taiga', 'raspberry', 'teal', 'violet', 'blue']

export default class ToysSection
{
    constructor(_options)
    {
        // Options
        this.resources = _options.resources
        this.objects = _options.objects
        this.materials = _options.materials

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setDominoes()
        this.setPyramid()
        this.setBalls()
    }

    add(_name, _position, _rotationZ, _color, _mass, _shadow, _sound)
    {
        return this.objects.add({
            base: this.resources.items[`toys${_name}Base`].scene,
            collision: this.resources.items[`toys${_name}Collision`].scene,
            offset: _position,
            rotation: new THREE.Euler(0, 0, _rotationZ),
            duplicated: true,
            material: this.materials.items[_color],
            shadow: _shadow,
            mass: _mass,
            physicsMaterial: { Ball: 'dummy', Domino: 'domino', Cube: 'toy' }[_name], // top kaygan, küp tutunur, domino taşları birbirine sürtünmez
            sleepSpeedLimit: _name === 'Cube' ? 0.25 : undefined, // piramit uyanınca yürümesin (8 sn'de 123 mm → 8 mm)
            soundName: _sound
        })
    }

    setDominoes()
    {
        // S kıvrımlı hat: y -13 → -22, x 6 ± 2.4. Taşlar yol boyunca eşit aralıkla, ince yüzü yola dik
        const spacing = 0.56
        const path = (_u) => new THREE.Vector2(6 + 2.4 * Math.sin(_u * Math.PI * 2), - 13 - 9 * _u)

        const points = []
        let previous = path(0)
        let travelled = spacing
        for(let i = 0; i <= 2000; i++)
        {
            const point = path(i / 2000)
            travelled += point.distanceTo(previous)
            previous = point
            if(travelled >= spacing)
            {
                travelled = 0
                const ahead = path(Math.min(1, i / 2000 + 0.001))
                const behind = path(Math.max(0, i / 2000 - 0.001))
                points.push({ point, angle: Math.atan2(ahead.y - behind.y, ahead.x - behind.x) })
            }
        }

        this.dominoes = points.map((_item, _index) => this.add(
            'Domino',
            new THREE.Vector3(_item.point.x, _item.point.y, 0),
            _item.angle,
            COLORS[_index % COLORS.length],
            0.4,
            { sizeX: 0.5, sizeY: 0.9, offsetZ: - 0.4, alpha: 0.3 },
            'wood'
        ))
    }

    setPyramid()
    {
        // 5-4-3-2-1 küp; her kat bir alttakinin ortasına oturur
        const size = 0.55
        const gap = 0.02
        const base = 5
        const origin = new THREE.Vector3(- 5, - 20, 0)

        this.pyramid = []
        for(let level = 0; level < base; level++)
        {
            const count = base - level
            for(let i = 0; i < count; i++)
            {
                const x = origin.x + (i - (count - 1) * 0.5) * (size + gap)
                const z = level * size + 0.001 // katlar tam temas: boşluk bırakınca başta oturup kayıyordu
                this.pyramid.push(this.add(
                    'Cube',
                    new THREE.Vector3(x, origin.y, z),
                    0,
                    COLORS[(level + i) % COLORS.length],
                    0.35,
                    { sizeX: 0.9, sizeY: 0.9, offsetZ: - 0.2, alpha: 0.3 },
                    'block'
                ))
            }
        }
    }

    setBalls()
    {
        this.balls = [
            [new THREE.Vector3(4.5, - 25.5, 0), 'raspberry'],
            [new THREE.Vector3(- 4.5, - 25.5, 0), 'teal'],
            [new THREE.Vector3(5, - 34.5, 0), 'taiga']
        ].map(([_position, _color]) => this.add(
            'Ball',
            _position,
            0,
            _color,
            0.6,
            { sizeX: 1.4, sizeY: 1.4, offsetZ: - 0.2, alpha: 0.35 },
            'rubber'
        ))
    }
}
